<template>
    <div class="relative overflow-hidden rounded-[2rem] bg-nomad-accent px-7 py-9 text-nomad-primary shadow-[0_1rem_2.5rem_rgba(23,25,35,0.08)] sm:px-10 sm:py-12 lg:px-16 lg:py-14">
        <div class="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-14">
            <div class="min-w-0 max-w-3xl">
                <p class="mb-3 text-xs font-extrabold uppercase tracking-[0.16em] text-nomad-primary/70">Let&apos;s build something useful</p>
                <h2 class="text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">{{ title }}</h2>
                <p class="mt-4 max-w-2xl text-base leading-relaxed text-nomad-primary/80 sm:text-lg">{{ subtitle }}</p>
            </div>
            <div class="shrink-0">
                <a :href="url" class="inline-flex items-center justify-center gap-2 rounded-full bg-nomad-primary px-6 py-3.5 text-sm font-extrabold text-nomad-light shadow-[0_0.6rem_1.2rem_rgba(23,25,35,0.16)] transition hover:-translate-y-0.5 hover:bg-black">
                    <span>{{ cta }}</span>
                    <ArrowRight class="h-4 w-4" aria-hidden="true" />
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import { ArrowRight } from '@lucide/vue';
export default {
    props: {
        title: String,
        subtitle: String,
        url: {
            type: String,
            default: '#'
        },
        cta: String
    },
    components: { ArrowRight }
}
</script>